module.exports = new __parcel__URL__("lang-icon.b99fc6cd.svg").toString();